var map = {
	"./ava_ingyenes_ikon.svg": 3031,
	"./jamh_ingyenes_ikon.svg": 9125,
	"./kbmo_ingyenes_ikon.svg": 4498,
	"./ktkh_ingyenes_ikon.svg": 5505,
	"./pmh_ingyenes_ikon.svg": 9118,
	"./szimh_ingyenes_ikon.svg": 7054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9081;